export default{
    leadingZeros: function(n, digits) {
        var zero = '';
        n = n.toString();
        if (n.length < digits) {
            for (var i = 0; i < digits - n.length; i++)
                zero += 0;
        }
        return zero + n;
    },
    getBirthToAge: function(birth)
    {
        const today = new Date();
        const birthDate = new Date(birth); 

        let age = today.getFullYear()
          - birthDate.getFullYear()
          + 1;
          
        return age;
    },
    getCurrentTime: function()
    {
        var date = new Date();
        return   this.leadingZeros(date.getHours(), 2) + ":" + this.leadingZeros(date.getMinutes(), 2) + ":" + this.leadingZeros(date.getSeconds(), 2);
    },
    getTodayDateTime: function()
    {
        var date = new Date();
        var month = date.getMonth() + 1;
        return date.getFullYear() + "-" + this.leadingZeros(month, 2) + "-" + this.leadingZeros(date.getDate(), 2);
         
    },
    convertDateTimeToTime: function(stamp)
    {
        var date = new Date(stamp);
        var month = date.getMonth() + 1;
        return this.leadingZeros(date.getHours(), 2) + ":" + this.leadingZeros(date.getMinutes(), 2);
    },
    convertTimeStampToStringDateTime: function(stamp)
    {
        var date = new Date(stamp);
        var month = date.getMonth() + 1;
        return date.getFullYear() + "-" + this.leadingZeros(month, 2) + "-" + this.leadingZeros(date.getDate(), 2) + " " +
            this.leadingZeros(date.getHours(), 2) + ":" + this.leadingZeros(date.getMinutes(), 2) + ":" + this.leadingZeros(date.getSeconds(), 2);
    },
    convertTimeStampToStringDateTime2: function(stamp)
    {
        var date = new Date(stamp);
        var month = date.getMonth() + 1;
        return date.getFullYear() + "." + this.leadingZeros(month, 2) + "." + this.leadingZeros(date.getDate(), 2) + " " +
            this.leadingZeros(date.getHours(), 2) + ":" + this.leadingZeros(date.getMinutes(), 2) + ":" + this.leadingZeros(date.getSeconds(), 2);
    },
    convertTimeStampToStringDateTimeReverse: function(stamp)
    {
        var date = new Date(stamp);
        var month = date.getMonth() + 1;
        return this.leadingZeros(month, 2) + "." + this.leadingZeros(date.getDate(), 2) + "." + date.getFullYear();
    },
    convertTimeStampToStringDateTime3: function(stamp)
    {
        
        var date = new Date(stamp);
        var month = date.getMonth() + 1;
        var text = '오전';
        var hour = date.getHours();
        if(date.getHours() >= 12)
        {
            text = '오후'

            if(hour != 12)
            {
                hour = hour - 12;
            }
        }

        return date.getFullYear() + "년 " + this.leadingZeros(month, 2) + "월 " + this.leadingZeros(date.getDate(), 2) + "일 " + text + " " +
            this.leadingZeros(hour, 2) + "시 " + this.leadingZeros(date.getMinutes(), 2) + "분";
    },
    convertTimeStampToStringDateTime4: function(stamp)
    {
        var date = new Date(stamp);     
        var month = date.getMonth() + 1;
        return date.getFullYear() + ". " + this.leadingZeros(month, 2) + ". " + this.leadingZeros(date.getDate(), 2) + "";
           
    },
    convertTimeStampToStringDateTime7: function(stamp)
    {
        var date = new Date(stamp);     
        var month = date.getMonth() + 1;
        return date.getFullYear() + "/" + this.leadingZeros(month, 2) + "/" + this.leadingZeros(date.getDate(), 2) + " " + this.leadingZeros(date.getHours(), 2) + ":" + this.leadingZeros(date.getMinutes(), 2);
           
    },
    convertTimeStampToStringDateTime5: function(stamp)
    {
        var date = new Date(stamp);     
        var month = date.getMonth() + 1;
        var text = '오전';
        var hour = date.getHours();
        if(date.getHours() >= 12)
        {
            text = '오후'

            if(hour != 12)
            {
                hour = hour - 12;
            }
        }
        // return text + " " + this.leadingZeros(hour, 2) + "시 " + this.leadingZeros(date.getMinutes(), 2) + "분";
        return this.leadingZeros(date.getHours(), 2) + ":" + this.leadingZeros(date.getMinutes(), 2);
    },
    convertTimeStampToStringDateTime6: function(stamp)
    {
        var date = new Date(stamp);     
        var month = date.getMonth() + 1;
        return date.getFullYear() + "-" + this.leadingZeros(month, 2) + "-" + this.leadingZeros(date.getDate(), 2) + "";
           
    },
    convertTimeStampToString: function(stamp, stamp2, dow)
    {
        const dowlist = ['일', '월', '화', '수', '목', '금', '토']
        if(!stamp)
        {
            return '-'
        }
        var date = new Date(stamp);        
        var date2 = new Date(stamp2);    

        var hour = date.getHours();
        var hour2 = date2.getHours();

        let dt1 = '오전 ';
        let dt2 = '오전 ';

        if(hour >= 12)
        {
            dt1 = '오후 '
            if(hour != 12)
            {
                hour = hour - 12;
            }
            
        }     
        if(hour2 >= 12)
        {
            dt2 = '오후 '
            if(hour2 != 12)
            {
                hour2 = hour2 - 12;
            }
        }  

        return this.leadingZeros(date.getMonth()+1, 2)+ "월 " +this.leadingZeros(date.getDate(), 2)+'일 (' + dowlist[dow] + ") " +dt1 + this.leadingZeros(hour, 2) + "시-" +this.leadingZeros(hour2, 2) +"시 ";
    },
    setComma: function(num)
    {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',')
    },
    subStractDate: function(stamp)
    {
        var date = new Date(stamp);
        date.setDate(date.getDate() -2);
        return date;
    },
    curYearToString: function() {
        var date = new Date();
        return date.getFullYear();
    },
    curMonthToString: function() {
        var date = new Date();
        var month = date.getMonth() + 1;
        return this.leadingZeros(month, 2);
    },
    curDateToString: function() {
        var dates = new Date();
        var date = dates.getDate()
        return this.leadingZeros(date, 2);
    },
    convert24To12: function(str)
    {
        //+ PM or AM
        var hour = str.substring(0, 2);
        var minute = str.substring(3, 5);

        hour = parseInt(hour)
        minute = parseInt(minute)

        if(hour >= 12)
        {
            hour -= 12;
            return hour + ':' + minute + ' PM'; 
        }
        else
        {
            return hour + ':' + minute + ' AM'; 
        }
    },
    calDistance: function(lat1, lon1, lat2, lon2)
    {
        const R = 6371; // 지구 반지름 (단위: km)
        const dLat = this.deg2rad(lat2 - lat1);
        const dLon = this.deg2rad(lon2 - lon1);
        const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                  Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                  Math.sin(dLon/2) * Math.sin(dLon/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        const distance = R * c * 1000; // 두 지점 간의 거리 (단위: km)
        return Math.floor(distance);
    },
    deg2rad: function(deg){
        return deg * (Math.PI/180);
    },
    containsNumber: function (input) {
        const regex = /\d/;
        return regex.test(input);
    },
    isNumeric: function (input) {
        const regex = /^\d+(\.\d+)?$/;
        return regex.test(input);
    },
    isValidBirthdate: function (input) {
        const regex = /^(?:[0-9]{2})(?:(?:0[1-9]|1[0-2])(?:0[1-9]|[12][0-9]|3[01]))$/;
        return regex.test(input);
    }
}


// WEBPACK FOOTER //
// ./src/utilities/convert.js